import React from "react";
import { Link } from "react-router-dom";
import Icon from "./Icon";
import ProductImage from "./ProductImage";
import { cartTotals, displayName, money } from "../utils";
import "./CartPanel.css";

// Cart contents with quantity controls. `readOnly` is used on the checkout summary.
const CartPanel = ({ lines, balance, busyId, onChangeQty, readOnly = false, headingId = "cart-title", footer }) => {
  const { count, total } = cartTotals(lines);

  if (!lines.length) {
    return (
      <div className="cart-empty">
        <span className="cart-empty-icon" aria-hidden="true">
          <Icon name="bag" size={26} />
        </span>
        <h2 id={headingId} className="cart-title">
          Your cart is empty
        </h2>
        <p>Add something you like and it will show up here.</p>
      </div>
    );
  }

  return (
    <div className="cart-panel">
      <div className="cart-head">
        <h2 id={headingId} className="cart-title">
          {readOnly ? "Order summary" : "Your cart"}
        </h2>
        <span className="cart-count">
          {count} {count === 1 ? "item" : "items"}
        </span>
      </div>
      <ul className="cart-lines">
        {lines.map((line) => {
          const name = displayName(line.name);
          return (
            <li key={line._id} className="cart-line">
              <ProductImage product={line} iconSize={22} className="cart-line-image" />
              <span className="cart-line-text">
                <span className="cart-line-name">{name}</span>
                {readOnly ? (
                  <span className="cart-line-meta">
                    Qty {line.qty} × {money(line.cost)}
                  </span>
                ) : (
                  <span className="cart-line-controls">
                    <span className="stepper stepper-sm" role="group" aria-label={`${name} quantity`}>
                      <button
                        type="button"
                        aria-label={`Remove one ${name}`}
                        disabled={busyId === line._id}
                        onClick={() => onChangeQty(line, line.qty - 1)}
                      >
                        −
                      </button>
                      <output aria-live="polite">{line.qty}</output>
                      <button
                        type="button"
                        aria-label={`Add one more ${name}`}
                        disabled={busyId === line._id}
                        onClick={() => onChangeQty(line, line.qty + 1)}
                      >
                        +
                      </button>
                    </span>
                    <span className="cart-line-meta">{money(line.cost)} each</span>
                  </span>
                )}
              </span>
              <span className="cart-line-total">{money(line.lineTotal)}</span>
            </li>
          );
        })}
      </ul>
      <dl className="cart-sums">
        <div>
          <dt>Subtotal</dt>
          <dd>{money(total)}</dd>
        </div>
        <div>
          <dt>Delivery</dt>
          <dd className="cart-free">Free</dd>
        </div>
        <div className="cart-sum-total">
          <dt>Total</dt>
          <dd>{money(total)}</dd>
        </div>
      </dl>
      {footer !== undefined ? (
        footer
      ) : (
        <>
          <Link to="/checkout" className="btn btn-primary btn-lg btn-block">
            Checkout
            <Icon name="arrowRight" size={18} />
          </Link>
          <p className="cart-note">
            {balance >= total
              ? `Paid from your QKart wallet · ${money(balance - total)} left after this order`
              : `Your wallet has ${money(balance)}, which isn't enough for this order.`}
          </p>
        </>
      )}
    </div>
  );
};

export default CartPanel;
